module.exports = __webpack_public_path__ + "pc/img/work_list2.81a20b32.jpg";